import React from 'react'

export default function FaceFeature({ scaleX, fill }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M5.07001 5.47C4.66001 6.15 4.00001 6.57999 3.26001 6.57999C2.01001 6.57999 1 5.33001 1 3.79001C1 2.25001 2.01001 1 3.26001 1"
        stroke={fill} // "#FFDC2E"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M67.8101 5.47C68.2201 6.15 68.8801 6.57999 69.6201 6.57999C70.8701 6.57999 71.8801 5.33001 71.8801 3.79001C71.8801 2.25001 70.8701 1 69.6201 1"
        stroke={fill} // "#FFDC2E"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  )
}
